import React, { Component } from 'react';
import DropDown from 'shared/components/DropDown/index';

export default class SubHeader extends Component {

  render() {
    return (
      <div className="alloc-card__header">

        {/* Title + subtitle */}
        <div className="alloc-card__title-block">
          <h1 className="alloc-card__title">Allocation</h1>
          <p className="alloc-card__subtitle">
            Make contract periodical allocation easier to understand and maintain.
          </p>
        </div>

        {/* Controls row: filters on left, Save Allocation on right */}
        <div className="alloc-header-controls">

          <div className="alloc-header-controls__filters">

            <div>
              <div className="alloc-header-select-wrap">
                <DropDown
                  name={"selected_group"}
                  value={this.props.selected_group}
                  onChange={this.props.onGroupChange}
                  data={this.props.group_data}
                  first_element={"--Select Group--"}
                />
              </div>
              <div style={{ minHeight: 16 }}>
                <span className="error-text">
                  {this.props.validator.message('selected_group', this.props.selected_group, 'required|gt:0', false, { default: 'This field is required.' })}
                </span>
              </div>
            </div>

            <div>
              <div className="alloc-header-select-wrap">
                <DropDown
                  name={"selected_facility"}
                  value={this.props.selected_facility}
                  onChange={this.props.onFacilityChange}
                  data={this.props.facilitydata}
                  first_element={"--Select Facility--"}
                />
              </div>
              <div style={{ minHeight: 16 }}>
                <span className="error-text">
                  {this.props.validator.message('selected_facility', this.props.selected_facility, 'required|gt:0', false, { default: 'This field is required.' })}
                </span>
              </div>
            </div>

            <button className="alloc-apply-btn" onClick={this.props.onApplyClick} type="button">
              Apply
            </button>

          </div>

          <button className="alloc-save-btn" onClick={this.props.saveClick} type="button">
            Save Allocation
          </button>

        </div>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/containers/PeriodicalConfig/periodical_subheader.js